import ArticleFooter from './ArticleFooter';

export default ArticleFooter;
